"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransition = void 0;
var react_1 = require("react");
exports.useTransition = function (enter, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.enterTimeout, enterTimeout = _c === void 0 ? 1 : _c, _d = _b.exitTimeout, exitTimeout = _d === void 0 ? 1 : _d;
    var _e = react_1.useState(enter ? 'entered' : 'exited'), state = _e[0], setState = _e[1];
    var firstRender = react_1.useRef(true);
    var enterTimeoutRef = react_1.useRef();
    var exitTimeoutRef = react_1.useRef();
    react_1.useEffect(function () {
        if (firstRender.current === true) {
            firstRender.current = false;
            return;
        }
        if (enter) {
            setState('entering');
            enterTimeoutRef.current = setTimeout(function () { return setState('entered'); }, enterTimeout);
        }
        else {
            setState('exiting');
            exitTimeoutRef.current = setTimeout(function () { return setState('exited'); }, exitTimeout);
        }
        return function () {
            enterTimeoutRef.current && clearTimeout(enterTimeoutRef.current);
            exitTimeoutRef.current && clearTimeout(exitTimeoutRef.current);
        };
    }, [enter]);
    return state;
};
//# sourceMappingURL=useTransition.js.map